import React, { useState, useEffect } from 'react';

import { LocationDTO, ProgramDTO } from '@peartherapeutics/weaver-api-client';
import { WeaverApiClientInstance } from 'api/weaverApiClientInstance';
import SelectProgram from 'components/common/SelectProgram';
import Program from 'utils/program';
import { programs, PROGRAM_CONFIG } from 'utils/constants';
import ErrorInterceptor from 'components/common/ErrorInterceptor';
import SelectLocation from 'components/common/SelectLocation';

import './styles.scss';
import AuthorizationComponent from 'components/common/AuthorizationComponent';
import { scopes } from 'utils/scope';
import CsvButtonPaginated from './CsvButtonPaginated';

export interface IOwnProps {
  patients: IFormattedPatientAdherenceDetails[] | [];
  searchTerm?: string;
  onClinicChange: (clinicId: string) => void;
  onClinicLoading: (isLoading: boolean) => void;
  onProgramChange: () => void;
  onQueryStringChange: (queryString: string) => void;
  setProgram?: (program: ProgramDTO) => void;
  isTableLoading: boolean;
}

const HeaderPaginated = (props: IOwnProps) => {
  const [clinics, setClinics] = useState<LocationDTO[]>([]);
  const [previousProgram, setPreviousProgram] = useState<ProgramDTO>();
  const { setProgram, searchTerm, patients, isTableLoading } = props;

  const getClinics = async () => {
    try {
      props.onClinicLoading(true);
      const { data: clinics } = await WeaverApiClientInstance.getAllLocations();
      setClinics(clinics);
    } catch (e) {
      ErrorInterceptor.error(e);
    } finally {
      props.onClinicLoading(false);
    }
  };

  const handleProgramChange = () => {
    const currentProgram: ProgramDTO = Program.get();
    if (previousProgram?.name !== currentProgram.name) {
      props.onProgramChange();
      setClinics([]);
      setPreviousProgram(currentProgram);
      getClinics();
    }
  };

  const handleQueryStringChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    props.onQueryStringChange(e.target.value);
  };

  useEffect(() => {
    return () => {
      Program.clear();
    };
  }, []);

  const programOptions: ProgramDTO[] = [
    {
      name: programs.RESET,
      id: '',
      label: PROGRAM_CONFIG[programs.RESET].name,
    },
    {
      name: programs.RESETO,
      id: '',
      label: PROGRAM_CONFIG[programs.RESETO].name,
    },
  ]; // TODO: [WB-2479] Remove this hardcoding
  return (
    <>
      <div
        data-testid={`${isTableLoading ? 'loading' : 'loaded'}`}
        styleName="title"
      >
        Patient Adherence
      </div>
      <div styleName="wrapper">
        <div styleName="section">
          <div styleName="select-wrapper select-program">
            <SelectProgram
              programs={programOptions}
              onChange={handleProgramChange}
              setProgram={setProgram}
            />
          </div>
          <div styleName="select-wrapper">
            <SelectLocation
              disabled={!previousProgram}
              options={clinics}
              placeholder="Select Location"
              onChangeLocation={(_: any, value: string) =>
                props.onClinicChange(value)
              }
              hasSelectAll
              width="300px"
            />
          </div>
          <AuthorizationComponent requiredScope={scopes.PATIENT_SEARCH}>
            <div styleName="input-wrapper">
              <input
                data-testid="search-box"
                type="text"
                placeholder="Search First Name, Last Name, or ID"
                value={searchTerm}
                onChange={handleQueryStringChange}
              />
              <div />
            </div>
          </AuthorizationComponent>
        </div>
        <div styleName="section">
          <CsvButtonPaginated
            csvData={patients}
            isTableLoading={isTableLoading}
          />
        </div>
      </div>
    </>
  );
};

export default HeaderPaginated;
